import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/app-routing.module.ts